// extracted by mini-css-extract-plugin
export default {"deleteWrap":"SiteDetail_deleteWrap__ILgk3"};